export default {
	title: 'سامانه رزرو وقت مشاوره',
	description: 'برای تنظيمات بيشتر رزرو وقت مشاوره، می‌توانید وقت محلی، زبان و واحد پول را تغییر دهید.',
	languageTitle: 'زبان مشاوره',
	languageTitleRight: 'فارسی',
	currencyTitle: 'واحد پول',
	currencyTitleValue: {
		Rial: 'ریال',
		Dollar: 'دلار کانادا',
		'+03:30': 'به وقت تهران',
		'-07:00': 'به وقت کانادا'
	},
	timezoneTitle: 'زمان محلی',
	languageDescription: 'با انتخاب زبان فقط لیست مشاورین که با این زبان صحبت می‌کنند نمایش داده خواهند شد.',
	currencyDescription: 'پرداخت حق مشاوره با واحد پولی انتخاب شده انجام خواهد شد.',
	timezoneDescription: 'کلیه رزروها به وقت محلی انتخابی شما خواهد بود.',
	button: 'شروع رزرو وقت',

	radioSelect: {
		enLanguage: 'زبان انگلیسی',
		faLanguage: 'زبان فارسی'
	},
	tehranTimezone: 'تهران',
	canadaTimezone: 'کانادا',
	time: 'به وقت',
	dollar: 'دلار کانادا',
	rial: 'تومان',
	duration: 'دقیقه',
	timezoneSearch: 'جستجو در عنوان کشور و شهر',

	htmlTitle: ' | سامانه رزرو وقت مشاوره',

	pm: 'بعد از ظهر',
	am: 'قبل از ظهر',

	free: 'رایگان'
}
